import script from "./ListCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListCard.vue?vue&type=script&setup=true&lang=ts"

import "./ListCard.vue?vue&type=style&index=0&id=36d8fd8b&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d8fd8b"]])

export default __exports__